import React, { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { Modal } from '../../../components/modal/index';
import { useLocale } from '../../../hooks/index';

export type DeleteStakeholderModalProps = {
  hasMultipleEmails?: boolean;
  isOpen: boolean;
  onDismiss: () => void;
  onSuccess: () => void;
  subEmailAction?: boolean;
};

const DeleteStakeholderModal: FC<DeleteStakeholderModalProps> = ({
  isOpen,
  onDismiss,
  onSuccess,
  hasMultipleEmails,
  subEmailAction,
}) => {
  const { messagesLocale } = useLocale();
  return (
    <Modal
      description={
        <AppFormattedMessage
          id={
            subEmailAction
              ? 'THIS_SUB_EMAIL_WILL_BE_REMOVED_FROM_STAKEHOLDER'
              : hasMultipleEmails
                ? 'DELETION_STAKEHOLDER_WITH_MULTIPLE_EMAILS'
                : 'ALL_ASSOCIATED_STAKEHOLDER_DATA_WILL_BE_LOST'
          }
        />
      }
      dismissButtonContent={<AppFormattedMessage id="NO_KEEP_3" />}
      isOpen={isOpen}
      onDismiss={onDismiss}
      onSuccess={onSuccess}
      successButtonContent={messagesLocale['CONFIRM_DELETE']}
      title={
        <>
          <AppFormattedMessage
            id={subEmailAction ? 'DELETE_SUB_EMAIL' : 'DELETE_STAKEHOLDER'}
            values={{ count: 1 }}
          />
          ?
        </>
      }
    />
  );
};

export default DeleteStakeholderModal;
